<template>
  <div>
    <b-list-group v-if="filteredList.length">
      <side-bar-item
        v-for="item in filteredList"
        :key="item.title"
        :item="item"
        @dashboardSelected="onLinkClick"
      />
    </b-list-group>
  </div>
</template>

<script>
import _ from 'lodash';
import SideBarItem from '@/components/dashboard/SideBarItem';

export default {
  props: ['menu'],
  components: { SideBarItem },
  data() {
    return {
      list: [],
    };
  },
  mounted() {
    this.list = _.cloneDeep(this.menu);
  },
  watch: {
    menu() {
      this.list = _.cloneDeep(this.menu);
    },
  },
  computed: {
    filteredList() {
      return this.list;
    },
  },
  methods: {
    onLinkClick(item) {
      if (item.href) {
        this.$emit('dashboardSelected', item.title);
      }
    },
  },
};
</script>